export function splitAfterFirstRow<T>(
  items: T[],
  columns: number,
): { firstRow: T[]; rest: T[] } {
  if (items.length === 0) return { firstRow: [], rest: [] };
  const count = Math.max(1, Math.floor(columns) || 1);
  const take = Math.min(count, items.length);
  return { firstRow: items.slice(0, take), rest: items.slice(take) };
}
